import { useEffect } from "react";
import {
  CompositeAsset,
  Favorite,
} from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { useFetchers } from "react-router-dom";
import { SearchCountResponse } from "../../../../common/api/decimal/methods/search.ts";

function isSearchCountResponse(
  arg: (CompositeAsset & { favorite: Favorite }) | SearchCountResponse
): arg is SearchCountResponse {
  return (arg as SearchCountResponse).count !== undefined;
}

export default function useSearchFavoritesSync<
  T extends (CompositeAsset & { favorite: Favorite }) | SearchCountResponse,
>(results: T[] | undefined, update: (results: T[]) => void) {
  const fetchers = useFetchers();

  // search does not revalidate so sync locally against static results

  useEffect(() => {
    const mutators = fetchers.filter(
      (f) =>
        f.state === "loading" &&
        f.formAction === "/home/actions/user/favorites" &&
        (f.formMethod === "PUT" || f.formMethod === "DELETE")
    );
    if (mutators.length && results?.length) {
      const updatedItems = [...results];
      let modified = false;
      mutators.forEach((f) => {
        const vbid = f.formData?.get("vbid") as string;
        const item = updatedItems.find((item) =>
          isSearchCountResponse(item)
            ? item.asset.manageAsset.vbid === vbid
            : item.manageAsset.vbid === vbid
        );
        const newVal = f.formMethod === "PUT";
        if (item) {
          const favorite = isSearchCountResponse(item)
            ? item.asset.favorite
            : item.favorite;
          if (favorite.isFavorited !== newVal) {
            favorite.isFavorited = newVal;
            modified = true;
          }
        }
      });
      if (modified) {
        update(updatedItems);
      }
    }
  }, [fetchers, results, update]);
}
